export const getApiErrorMessage = (error, t, options = {}) => {
  const {
    errorCodeMap = {},
    statusMap = {},
    validationMessageMap = {},
    fallbackKey = 'general.something_wrong',
  } = options;

  const errorCode = error?.response?.data?.error_code;
  if (errorCode && errorCodeMap[errorCode]) {
    return t(errorCodeMap[errorCode]);
  }

  const status = error?.response?.status;
  if (status && statusMap[status]) {
    return t(statusMap[status]);
  }

  const validationErrors = error?.response?.data?.errors;
  if (Array.isArray(validationErrors) && validationErrors.length > 0) {
    const combined = validationErrors.join(' ');
    const matchedSubstring = Object.keys(validationMessageMap).find((substring) =>
      combined.includes(substring)
    );
    if (matchedSubstring) {
      return t(validationMessageMap[matchedSubstring]);
    }
    return validationErrors[0];
  }

  const responseMessage = error?.response?.data?.message;
  if (responseMessage) {
    return responseMessage;
  }

  if (!error?.response) {
    return t('general.network_error');
  }

  return t(fallbackKey);
};
